import { pageMetadataFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { DEFAULT_REGION_CODE } from '@/data'
import { headerWithCtas, imageAsset } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  hideHeaderContent,
  ${headerWithCtas.fragment('headerContent')},
  ${imageAsset.fragment('backgroundSvg')},
  orderOfStates[],
  showPrivateDiningOnly,
  showPrivateDiningOnly == true => {
    'items': *[
      _type == "location" && 
    $language in enabledRegions && 
      coalesce(
        locationData.i18n[$language].showInLists,
        locationData.i18n.${DEFAULT_REGION_CODE}.showInLists
      ) == true &&
      coalesce(
        locationData.i18n[$language].hasPrivateDining,
        locationData.i18n.${DEFAULT_REGION_CODE}.hasPrivateDining
      ) == true
    ] {
      ${pageMetadataFields}
    }
  },
  showPrivateDiningOnly == false => {
    'items': *[
      _type == "location" && 
      $language in enabledRegions && 
      coalesce(
        locationData.i18n[$language].showInLists,
        locationData.i18n.${DEFAULT_REGION_CODE}.showInLists
      ) == true
    ] {
      ${pageMetadataFields}
    }
  }
`

export const fragment = (name = 'locationsList') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
